import { API, authClient } from "../index";

export const getObraPlanningStatus = (accessToken) => {
  return authClient(accessToken).get(`${API}/obra-planning-status`);
};
